import * as types from "./dashboardActionTypes";
import { call, put, takeLatest, select } from "redux-saga/effects";
import {
  loadSecurityAlertsLastMonthSuccess,
  loadSecurityAlertsLastWeekSuccess,
  loadIncidentsSuccess,
  loadIncidentsFailed,
  loadSecurityAlertsForLastMonthFailed,
  loadSecurityAlertsForLastWeekFailed,
  loadSystemStatusSuccess,
  loadSystemStatusFailed,
  loadLogsPerDaySuccess,
  loadLogsPerDayFailed,
  loadDeviceGroupsSuccess,
  loadDeviceGroupsFailed
} from "./dashboardActions";
import ServiceApi from "./api";

export const getOidc = state => state.oidc;

function* loadSecurityAlertsForLastMonth() {
  try {
    let oidc = yield select(getOidc);
    const securityAlerts = yield call(
      ServiceApi.getSecurityAlertsForLastMonth,
      oidc.user
    );
    yield put(loadSecurityAlertsLastMonthSuccess(securityAlerts));
  } 
   catch (e) {
        yield put(loadSecurityAlertsForLastMonthFailed(e.message));
   }
}

export function* loadSecurityAlertsLastMonthSaga() {
  yield takeLatest(
    types.LOAD_SECURITY_ALERTS_FOR_LAST_MONTH,
    loadSecurityAlertsForLastMonth
  );
}

function* loadSecurityAlertsForLastWeek() {
  try {
    let oidc = yield select(getOidc);
    const securityAlerts = yield call(
      ServiceApi.getSecurityAlertsLastWeek,
      oidc.user
    );
    yield put(loadSecurityAlertsLastWeekSuccess(securityAlerts));
  } catch (e) {
    yield put(loadSecurityAlertsForLastWeekFailed(e.message));
  }
}

export function* loadSecurityAlertsLastWeekSaga() {
  yield takeLatest(
    types.LOAD_SECURITY_ALERTS_LAST_WEEK,
    loadSecurityAlertsForLastWeek
  );
}

function* loadIncidents() {
  try {
    let oidc = yield select(getOidc);
    const incidentsOverview = yield call(ServiceApi.getIncidentsOverview, 
        oidc.user);
    yield put(loadIncidentsSuccess(incidentsOverview));
  } catch (e) {
    yield put(loadIncidentsFailed(e.message));
  }
}

export function* loadIncidentsSaga() {
  yield takeLatest(types.LOAD_INCIDENTS, loadIncidents);
}

function* loadSystemStatus() {
  try {
    let oidc = yield select(getOidc);
    const systemStatus = yield call(ServiceApi.getSystemStatus, oidc.user);
    yield put(loadSystemStatusSuccess(systemStatus));
  } catch (e) {
    yield put(loadSystemStatusFailed(e.message));
  }
}

export function* loadSystemStatusSaga() {
  yield takeLatest(types.LOAD_SYSTEM_STATUS, loadSystemStatus);
}

function* loadLogsPerDay() {
  try {
    let oidc = yield select(getOidc);
    const logsPerDay = yield call(ServiceApi.getLogsPerDay, oidc.user);
    yield put(loadLogsPerDaySuccess(logsPerDay));
  } catch (e) {
    yield put(loadLogsPerDayFailed(e.message));
  }
}

export function* loadLogsPerDaySaga() {
  yield takeLatest(types.LOAD_LOGS_PER_DAY, loadLogsPerDay);
}

export function* loadDeviceGroups() {
  try {
    let oidc = yield select(getOidc);
    const response = yield call(ServiceApi.getDeviceGroups, oidc.user);
    yield put(loadDeviceGroupsSuccess(response.deviceGroups));
  } catch (e) {
    yield put(loadDeviceGroupsFailed(e.message));
  }
}

export function* loadDeviceGroupsSaga() {
  yield takeLatest(types.LOAD_DEVICE_GROUPS, loadDeviceGroups);
}



// WEBPACK FOOTER //
// ./src/dashboard/sagas.js